import { styled } from '@mui/material'

export const Header = styled('div')(({ theme }) => ({
  display: 'flex',
  flexWrap: 'wrap',
  justifyContent: 'center',
  margin: '0 auto 3rem',
  paddingLeft: '1rem',
  [theme.breakpoints.down('lg')]: {
    maxWidth: 514,
  },
  [theme.breakpoints.down('sm')]: {
    margin: '0 auto 1rem',
  },
  [theme.breakpoints.down(520)]: {
    maxWidth: 418,
  },
  [theme.breakpoints.down(410)]: {
    maxWidth: 336,
  },
  '& >div': {
    maxWidth: 150,
    width: '100%',
    margin: '0 1rem 1rem 0',
    '& .MuiInput-root': {
      height: 45,
      margin: 0,
    },
  },
  '& .specialty-area': {
    [theme.breakpoints.down(410)]: {
      maxWidth: 'unset',
    },
  },
  '& .gender': {
    maxWidth: 85,
    [theme.breakpoints.down(520)]: {
      maxWidth: '45%',
    },
  },
  '& .specialty': {
    maxWidth: 210,
    [theme.breakpoints.down(410)]: {
      maxWidth: 'unset',
    },
  },
  '& .language': {
    maxWidth: 100,
    [theme.breakpoints.down(520)]: {
      maxWidth: 180,
    },
    [theme.breakpoints.down(410)]: {
      maxWidth: '45%',
    },
  },
  '& .location': {
    [theme.breakpoints.down(520)]: {
      maxWidth: '55%',
    },
  },
  '& .age': {
    maxWidth: 80,
    [theme.breakpoints.down(520)]: {
      maxWidth: '35%',
    },
  },
  '& .title': {
    maxWidth: 70,
    [theme.breakpoints.down(520)]: {
      maxWidth: '25%',
    },
    [theme.breakpoints.down(410)]: {
      maxWidth: '25%',
    },
  },
  '& .provider-name': {
    maxWidth: 180,
    [theme.breakpoints.down(520)]: {
      maxWidth: '65%',
    },
  },

  '& input[type=text]': {
    border: 'none',
  },

  '& input[inputmode=numeric]': {
    '&::placeholder': {
      opacity: 0.6,
    },
    paddingBottom: 0,
    paddingLeft: 0,
    paddingRight: 0,
  },
}))
